import React from "react";

const Footer = () => {
    return (
        <div className="absolute-center">
            Made with ❤️ by Nitika
        </div>
    )
}

export default Footer;